import { Http } from '../../../../support';
import GetNewListHighlighted from '../../../../support/GetNewListHighlighted';

export const initialState = {
  selectedTab: 'todo',
  result: undefined,
  error: undefined,
  busy: false,
  data: [],
  filters: {
    page: 1,
    search: '',
  },
  pagination: {
    limit: 25,
  },
};

const highlight = (store, item) => {
  const fullList = store.state.admin.reportes.clientes.list.data;

  const newList = GetNewListHighlighted.make(fullList, item, true);

  store.setState((state) => {
    state.admin.reportes.clientes.list.data = newList;
  });

  setTimeout(() => {
    const newList = GetNewListHighlighted.make(fullList, item, false);

    store.setState((state) => {
      state.admin.reportes.clientes.list.data = newList;
    });
  }, 5000);
};

const setPartialState = (store, data) => {
  store.setState((state) => {
    state.admin.reportes.clientes.list = {
      ...state.admin.reportes.clientes.list,
      ...data,
    };
  });
};

const paginate = async (store, meta) => {
  store.setState((state) => {
    state.admin.reportes.clientes.list = {
      ...state.admin.reportes.clientes.list,
      busy: true,
      filters: {
        ...state.admin.reportes.clientes.list.filters,
        ...meta,
      },
      pagination: {
        ...state.admin.reportes.clientes.list.pagination,
        limit: meta?.limit ?? 25,
      },
    };
  });


  try {
    const { pagination, filters } = store.state.admin.reportes.clientes.list;
    const params = {
      ...filters,
      ...meta,
      limit: pagination.limit,
    };

    const response = await Http.get('/api/clientes', { params });

    store.setState((state) => {
      state.admin.reportes.clientes.list = {
        ...state.admin.reportes.clientes.list,
        busy: false,
        data: response.data,
        pagination: {
          ...state.admin.reportes.clientes.list.pagination,
          ...response.meta.pagination,
        },
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.admin.reportes.clientes.list.busy = false;
      state.admin.reportes.clientes.list.error = error.data || error;
    });
  }
};

const ReporteClienteListStore = {
  state: () => initialState,
  actions: {
    paginate,
    highlight,
    setPartialState,
  },
};

export default ReporteClienteListStore;
